import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  Modal,
  PixelRatio,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Colours from "../../utils/Colours";
import { useQuery } from "@tanstack/react-query";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import { useEffect, useState } from "react";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
//import BusinessBankDetails from "./BusinessBankDetails";
import * as ImageManipulator from "expo-image-manipulator";
import { File } from "expo-file-system";
//import * as FileSystem from "expo-file-system";
import * as ImagePicker from "expo-image-picker";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import CalenderIcon from "../../icons/CalenderIcon";
import { useNavigation, useRoute } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import { Image } from "expo-image";
import FowardFlatArrow from "../../icons/FowardFlatArrow";
const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MAX_IMAGE_SIZE_MB = 1;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

const TablesForBidding = () => {
  const [isTableNameFormClicked, setIsTableNameFormClicked] = useState(false);
  const [isshowImageFormClicked, setIsshowImageFormClicked] = useState(false);
  const [isTablePriceFormClicked, setIsTablePriceFormClicked] = useState(false);

  const [isCreatedClicked, setIsCreatedClicked] = useState(false);
  const [isDate1FormClicked, setIsDate1FormClicked] = useState(false);
  const [isDate2FormClicked, setIsDate2FormClicked] = useState(false);
  const [isShowCapFormClicked, setIsShowCapFormClicked] = useState(false);
  const [isPosterImageFormClicked, setIsPosterImageFormClicked] = useState(false);
  const [isDateTimeFormClicked, setIsDateTimeFormClicked] = useState(false);
  const [isLocationFormClicked, setIsLocationFormClicked] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading3, setIsLoading3] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showDateModal2, setShowDateModal2] = useState(false);

  const [selectedBidEndDate, setSelectedBidEndDate] = useState({});
  const [selectedDate, setSelectedDate] = useState();
  const [isDateSelected, setIsDataSelected] = useState(true);
  const [selectedDateAndTime, setSelectedDateAndTime] = useState({});
  const [showDateModal, setShowDateModal] = useState(false);
  const [selectedTime, setSelectedTime] = useState();

  const [tableData, setTableData] = useState({});

  const [activeDateField, setActiveDateField] = useState(null);

  const [tableName, setTableName] = useState("");
  const [tablePrice, setTablePrice] = useState("");
  const [bidEndDate, setBidEndDate] = useState({});
  const [tableUseDate, setTableUseDate] = useState({});

  const [showCaption, setShowCaption] = useState("");
  const [image, setImage] = useState(null);
  const [location, setLocation] = useState("");
  const [dateTime, setDateTime] = useState("");

  const [showShowForm, setShowShowForm] = useState(false);
  const [selectedShowId, setSelectedShowId] = useState(null);
  const [selectedShow, setSelectedShow] = useState(null);
  const [hasSelectedShow, setHasSelectedShow] = useState(false);
  const [showDateActions, setShowDateActions] = useState(false);
  const [selectedTags, setSelectedTags] = useState(null);

  const axiosPrivate = useAxiosPrivate();
  const navigation = useNavigation();
  const route = useRoute();
  const { selectedBrandData } = route.params;

  useEffect(() => {
    console.log("hasSelectedShow", hasSelectedShow);

    if (hasSelectedShow) {
      console.log("hasSelectedShow2", hasSelectedShow);

      formValidation();
    }
  }, [hasSelectedShow]);

  useEffect(() => {
    if (showShowForm === true) {
      setSelectedShow(null);
      setSelectedShowId(null);
    }
  }, [showShowForm]);
  useEffect(() => {
    console.log("selectedShow", selectedShow);
  }, [selectedShow]);

  const categories = ["Nightclub", "Pool side", "Roof top", "Lounge", "Eventspace reserved area"];

  const getShowsData = async () => {
    console.log("this");
    const response = await axiosPrivate.get(`/getshows/getshows/${selectedBrandData._id}`);
    return response.data.data;
  };

  const handleTagSelection = (tag) => {
    if (selectedTags === tag) {
      setSelectedTags(null);
      //console.log('TAGS', tag)
    } else {
      setSelectedTags(tag);
      //console.log('TAGS2', tag)
    }
  };

  const {
    data: showsData,
    isLoading: isLoading2,
    isError: isError2,
  } = useQuery({
    queryKey: ["showsData"],
    queryFn: getShowsData,
    enabled: !!selectedBrandData?._id,
  });

  const handleTableName = (text) => {
    setTableName(text);
  };
  const handleTablePrice = (text) => {
    setTablePrice(text.toLocaleString());
  };
  const handleBidEndDate = (text) => {
    setBidEndDate(text);
  };
  const handleBidUseDate = (text) => {};

  const handleShowCaption = (text) => {
    setShowCaption(text);
  };
  const handleLocation = (text) => {
    setLocation(text);
  };
  const handleDateTime = (text) => {
    setDateTime(text);
  };

  const normalizePrice = (value) => {
    if (!value) return 0;
    return Number(value.replace(/,/g, ""));
  };

  const formValidationShows = () => {
    if (showCaption === "") {
      console.log("Create clicked");

      setIsShowCapFormClicked(true);
    } else if (image === null) {
      console.log("Create clickedx");

      setIsshowImageFormClicked(true);
    } else if (location === "") {
      console.log("Create clickedg");

      setIsLocationFormClicked(true);
    }
  };

  const formValidation = async (replaceDates) => {
    console.log("SUBMIT CHECK → hasSelectedShow:", hasSelectedShow);
    console.log("SUBMIT CHECK → selectedShow:", selectedShow);

    if (tableName === "") {
      console.log("Create clickedT");

      setIsTableNameFormClicked(true);
    } else if (tablePrice === "") {
      console.log("Create clickedB");

      setIsTablePriceFormClicked(true);
    } else if (selectedTags === null) {
      setErrorMessage("Please select table location");
      setShowDateActions(false);
      setIsErrorCompVisible(true);
    } else if (!bidEndDate || Object.keys(bidEndDate).length === 0) {
      console.log("Create clickedkk");

      setIsDate1FormClicked(true);
    } else if (!tableUseDate || Object.keys(tableUseDate).length === 0) {
      console.log("Create clickedvcb");

      setIsDate2FormClicked(true);
    } else if (!selectedShow && location === "" && image === null && showCaption === "") {
      // } else if (!hasSelectedShow) {
      console.log("selectedShow", selectedShow);
      console.log("location", location);
      console.log("image", image);
      console.log("showCaption", showCaption);

      console.log("Create clickedoo");

      formValidationShows();
      setShowShowForm(true);
    } else {
      console.log("Create clickedp");

      const tableObjData = {
        associateBrand: selectedBrandData._id,
        tableName,
        tablePrice: normalizePrice(tablePrice),
        bidEndDate,
        tableUseDate,
        showCaption,
        image,
        location,
        dateTime,
        selectedShow,
        selectedTags,
        replaceDates,
      };
      setTableData(tableObjData);
      console.log("All Good");
      console.log("tableName", tableName);
      console.log("tablePrice", tablePrice);
      console.log("bidEndDate", bidEndDate);
      console.log("tableUseDate", tableUseDate);
      console.log("showCaption", showCaption);
      console.log("image", image);
      console.log("location", location);
      console.log("dateTime", dateTime);
      console.log("selectedShow", selectedShow);
      console.log("selectedTags", selectedTags);

      setTimeout(() => {
        setIsCreatedClicked(true);
      }, 50);

      try {
        // if (accountNumber === "") {
        //   setIsAccountNameFormClicked(true);
        // } else {

        const tableShowsDataJSON = JSON.stringify(tableObjData);

        const formData = new FormData();
        formData.append("tableShowsDataJSON", tableShowsDataJSON);

        //console.log('userDataJSON', userDataJSON)
        // navigate.push('my_city_state', { userDataObj_v2 })

        const showImage = tableObjData.image;

        if (showImage) {
          const uriParts = showImage.split(".");
          const fileType = uriParts[uriParts.length - 1];

          formData.append("showImage", {
            uri: Platform.OS === "ios" ? showImage.replace("file://", "") : showImage,
            type: `image/${fileType}`,
            name: "showImage", // Ensure a unique name
          });
        }

        setIsLoading3(true);

        const response = await axiosPrivate.post("/tableShowsData/tableShowsData", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status === 200 || response.status === 201) {
          console.log("response.data", response.data);

          //  queryClient.invalidateQueries(["brandData"]);
          if (isErrorCompVisible === true) {
            setIsErrorCompVisible(false);
          }
          resetForm();
          setSuccessMessage(response.data.message);
          setIsSuccessCompVisible(true);
        }
        // }
      } catch (error) {
        console.log("ERRORE", error);

        const data = error?.response?.data;

        if (data?.code === "SHOW_DATE_MISMATCH") {
          setErrorMessage(data.message);
          setShowDateActions(true);
          setIsErrorCompVisible(true);
        } else if (data?.code === "SHOW_ALREADY_LIVE") {
          setErrorMessage(data.message);
          setShowDateActions(false);
          setIsErrorCompVisible(true);
        } else {
          setErrorMessage(data?.message || "An error occurred");
          setIsErrorCompVisible(true);
        }
      } finally {
        setIsLoading3(false);
      }
    }
  };

  const resetForm = () => {
    // Table fields
    setTableName("");
    setTablePrice("");
    setBidEndDate({});
    setTableUseDate({});

    // Show fields
    setShowCaption("");
    setLocation("");
    setDateTime(null);
    setSelectedShow(null);
    setImage(null);

    // UI / state flags
    setShowShowForm(false);
    setIsShowCapFormClicked(false);
    setIsshowImageFormClicked(false);
    setIsLocationFormClicked(false);
    //   setIsDateFormClicked(false);
    setIsDate2FormClicked(false);

    // Optional
    //setReplaceDates(null);
  };

  // const prepareImageForUpload = async (imageUri) => {
  //   try {
  //     const fileInfo = await FileSystem.getInfoAsync(imageUri);

  //     if (fileInfo.size && fileInfo.size <= MAX_IMAGE_SIZE_BYTES) {
  //       // Already under 1MB, return as-is
  //       //console.log(`Image is already ${Math.round(fileInfo.size / 1024)} KB`);
  //       return imageUri;
  //     }

  //     //console.log(`Image too large: ${Math.round(fileInfo.size / 1024)} KB, compressing...`);
  //     let compressRatio = 0.9;
  //     let compressed = null;

  //     while (compressRatio > 0.1) {
  //       compressed = await ImageManipulator.manipulateAsync(imageUri, [], {
  //         compress: compressRatio,
  //         format: ImageManipulator.SaveFormat.JPEG,
  //       });

  //       const compressedInfo = await FileSystem.getInfoAsync(compressed.uri);

  //       if (compressedInfo.size && compressedInfo.size <= MAX_IMAGE_SIZE_BYTES) {
  //         console.log(`Compressed to ${Math.round(compressedInfo.size / 1024)} KB`);
  //         return compressed.uri;
  //       }

  //       compressRatio -= 0.1;
  //     }

  //     // console.warn('Could not get image under 1MB. Returning best attempt.');
  //     return compressed ? compressed.uri : imageUri;
  //   } catch (error) {
  //     // console.error('Image compression failed:', error);
  //     return imageUri; // fallback to original
  //   }
  // };

  const prepareImageForUpload = async (imageUri, fileSize) => {
    try {
      if (fileSize && fileSize <= MAX_IMAGE_SIZE_BYTES) {
        return imageUri;
      }

      let compressRatio = 0.9;
      let compressed = null;

      while (compressRatio > 0.1) {
        compressed = await ImageManipulator.manipulateAsync(imageUri, [], {
          compress: compressRatio,
          format: ImageManipulator.SaveFormat.JPEG,
        });

        const compressedFile = new File(compressed.uri);

        if (compressedFile.size && compressedFile.size <= MAX_IMAGE_SIZE_BYTES) {
          return compressed.uri;
        }

        compressRatio -= 0.1;
      }

      return compressed ? compressed.uri : imageUri;
    } catch (error) {
      console.error("Compression failed:", error);
      return imageUri;
    }
  };

  const pickImageFromPhone = async () => {
    console.log("this here");
    try {
      setIsLoading(true);

      console.log("this here also");

      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ["images"],
        allowsEditing: true,
        aspect: [4, 4],
        quality: 1,
        //   selectionLimit: 4 - images.length
      });

      console.log("results", result);
      console.log("this here ttoo");

      // if (!result.canceled) {
      //   //console.log('result:', result)
      //   //setImages([...images, result.assets[0].uri]);
      //   console.log("problem starts here");
      //   console.log("result", result);

      //   let imageUri = result.assets[0].uri;
      //   console.log("inside if");

      //   console.log("imageUri", imageUri);

      //   // Check file size using FileSystem
      //   const fileInfo = await FileSystem.getInfoAsync(imageUri);
      //   const fileSizeInMB = fileInfo.size / (1024 * 1024); // convert bytes to MB

      //   console.log("xosksp");

      //   console.log("fileInfo", fileInfo);

      //   console.log(`Image size: ${fileSizeInMB.toFixed(2)} MB`);

      //   if (fileSizeInMB > 65) {
      //     setErrorMessage(
      //       `Image too large: The selected image is ${fileSizeInMB.toFixed(
      //         2,
      //       )} MB. Please choose one below.`,
      //     );
      //     setIsErrorCompVisible(true);
      //     return; // stop further action
      //   }
      //   console.log("okkkeeu");

      //   const processedImageUri = await prepareImageForUpload(imageUri);
      //   // const processedImageUri = imageUri // We will not be compressing images again

      //   console.log("processedImageUri", processedImageUri);

      //   setImage(processedImageUri);
      // }

      if (!result.canceled) {
        const asset = result.assets[0];

        const imageUri = asset.uri;
        console.log("inside if");
        console.log("imageUri", imageUri);

        const fileSizeInMB = asset.fileSize / (1024 * 1024);
        console.log(`Image size: ${fileSizeInMB.toFixed(2)} MB`);

        if (fileSizeInMB > 65) {
          setErrorMessage(`Image too large: ${fileSizeInMB.toFixed(2)} MB`);
          setIsErrorCompVisible(true);
          return;
        }

        const processedImageUri = await prepareImageForUpload(imageUri);
        console.log("processedImageUri", processedImageUri);

        setImage(processedImageUri);
      }
      console.log("fine here");
    } catch (error) {
      console.error("Image picker error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCalenderDateModal = () => {
    setActiveDateField("bidEndDate");
    setShowDateModal(true);
  };
  const handleCalenderDateModal2 = () => {
    setActiveDateField("tableUseDate");
    setShowDateModal(true);
  };
  const handleCreatedClicked = () => {
    formValidation();
  };

  const handleReplaceShowDate = () => {
    const replaceShow = "showWithTableDate";
    formValidation(replaceShow);
  };
  const handleReplaceTableDate = () => {
    const replaceTable = "tableWithShowDate";
    formValidation(replaceTable);
  };
  const handleSelectedShow = (item) => {
    setSelectedShowId((prevId) => {
      if (prevId === item._id) {
        setSelectedShow(null); // or {}
        return null;
      } else {
        setSelectedShow(item);
        return item._id;
      }
    });
  };

  return (
    <SafeAreaView style={{ backgroundColor: "white" }}>
      <TopHeaderComponent
        headerText={"Create Meeza table"}
        hideScreen={() => navigation.goBack()}
      />
      <ScrollView
        style={styles.componentStyle}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.formaContainer}>
          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Table name/ID
          </Text>
          <AppTextInput
            style={[styles.formstyle, isTableNameFormClicked && styles.focusedBorder]}
            placeholder="Table name"
            onFocus={() => setIsTableNameFormClicked(true)}
            onBlur={() => setIsTableNameFormClicked(false)}
            onChangeText={(text) => {
              handleTableName(text);
            }}
          />

          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Table starting price
          </Text>
          <AppTextInput
            style={[styles.formstyle, isTablePriceFormClicked && styles.focusedBorder]}
            placeholder="Amount"
            keyboardType="numeric"
            value={tablePrice}
            onFocus={() => setIsTablePriceFormClicked(true)}
            onBlur={() => setIsTablePriceFormClicked(false)}
            onChangeText={(text) => {
              // const numericValue = text.replace(/[^0-9]/g, "");
              const numericValue = Number(text.replace(/\D/g, ""));
              handleTablePrice(numericValue);
            }}
          />

          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Table Location
          </Text>

          <View style={styles.tagsViewStyle}>
            {categories.map((tag) => (
              <TouchableOpacity
                key={tag}
                style={{
                  backgroundColor: selectedTags === tag ? Colours.PRIMARY : "white",
                  borderRadius: dynamicSize(20),
                  padding: dynamicSpacing(7),
                  margin: dynamicSpacing(3),
                }}
                onPress={() => handleTagSelection(tag)}
              >
                <Text
                  style={{
                    fontFamily: "Sen-Regular",
                    color: selectedTags === tag ? "white" : Colours.DARKGRAY,
                  }}
                >
                  {tag}
                </Text>
              </TouchableOpacity>
            ))}
          </View>

          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Date the bid will end
          </Text>
          {/* <AppTextInput
          style={[styles.formstyle, isDate1FormClicked && styles.focusedBorder]}
          placeholder="End date"
          onFocus={() => setIsDate1FormClicked(true)}
          onBlur={() => setIsDate1FormClicked(false)}
          onChangeText={(text) => {
            handleBidEndDate(text);
          }}
        /> */}

          <TouchableOpacity
            style={[styles.formstyle, isDate1FormClicked && styles.focusedBorder]}
            onFocus={() => setIsDate1FormClicked(true)}
            onBlur={() => setIsDate1FormClicked(false)}
            onPress={handleCalenderDateModal}
          >
            {/* {Object.keys(selectedBidEndDate).length === 0 ? ( */}
            {Object.keys(bidEndDate).length === 0 ? (
              isDateSelected && (
                <View style={styles.dateBox}>
                  <Text style={styles.dateTxt}>Pick a date</Text>

                  <CalenderIcon
                    color={Colours.DARKLIGHTGRAY}
                    width={dynamicSize(25)}
                    height={dynamicSize(25)}
                  />
                </View>
              )
            ) : (
              <View style={styles.dateBox}>
                <Text style={styles.enteredDateTxt}>
                  {/* {selectedBidEndDate.selectedDate.toDateString()} */}
                  {bidEndDate.selectedDate.toDateString()} - {bidEndDate.selectedTime}
                </Text>

                <CalenderIcon
                  color={Colours.DARKLIGHTGRAY}
                  width={dynamicSize(25)}
                  height={dynamicSize(25)}
                />
              </View>
            )}
          </TouchableOpacity>

          <Text
            style={{
              fontSize: dynamicFontSize(15),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
            }}
          >
            Date the table will be used
          </Text>

          <TouchableOpacity
            style={[styles.formstyle, isDate2FormClicked && styles.focusedBorder]}
            onFocus={() => setIsDate2FormClicked(true)}
            onBlur={() => setIsDate2FormClicked(false)}
            onPress={handleCalenderDateModal2}
          >
            {/* {Object.keys(selectedBidEndDate).length === 0 ? ( */}
            {Object.keys(tableUseDate).length === 0 ? (
              isDateSelected && (
                <View style={styles.dateBox}>
                  <Text style={styles.dateTxt}>Pick a date</Text>

                  <CalenderIcon
                    color={Colours.DARKLIGHTGRAY}
                    width={dynamicSize(25)}
                    height={dynamicSize(25)}
                  />
                </View>
              )
            ) : (
              <View style={styles.dateBox}>
                <Text style={styles.enteredDateTxt}>
                  {/* {selectedBidEndDate.selectedDate.toDateString()} */}
                  {tableUseDate.selectedDate.toDateString()} - {tableUseDate.selectedTime}
                </Text>

                <CalenderIcon
                  color={Colours.DARKLIGHTGRAY}
                  width={dynamicSize(25)}
                  height={dynamicSize(25)}
                />
              </View>
            )}
          </TouchableOpacity>
        </View>

        <TouchableOpacity
          style={styles.formaContainer}
          onPress={() => setShowShowForm((prev) => !prev)}
        >
          <View style={styles.flatArrowContainer}>
            <Text
              style={{
                fontSize: dynamicFontSize(17),
                color: Colours.DARKGRAY,
                fontFamily: "Sen-Bold",
                //   textAlign: "center",
                // marginBottom: dynamicSpacing(15),
              }}
            >
              {showShowForm ? "Hide show form" : "Create a show for the table"}
            </Text>
            <FowardFlatArrow color={Colours.PRIMARY} rotate={showShowForm ? "90deg" : "0deg"} />
          </View>
        </TouchableOpacity>

        {showShowForm && (
          <View style={styles.formaContainer}>
            <Text
              style={{
                fontSize: dynamicFontSize(15),
                color: Colours.DARKGRAY,
                fontFamily: "Sen-Regular",
              }}
            >
              Show caption
            </Text>
            <AppTextInput
              style={[styles.formstyle, isShowCapFormClicked && styles.focusedBorder]}
              placeholder="Caption"
              onFocus={() => setIsShowCapFormClicked(true)}
              onBlur={() => setIsShowCapFormClicked(false)}
              onChangeText={(text) => {
                handleShowCaption(text);
              }}
            />

            <Text
              style={{
                fontSize: dynamicFontSize(15),
                color: Colours.DARKGRAY,
                fontFamily: "Sen-Regular",
              }}
            >
              Poster
            </Text>
            {isLoading ? (
              <ActivityIndicator size="large" color={Colours.PRIMARY} />
            ) : (
              <TouchableOpacity
                style={[styles.photoViewStyle, isPosterImageFormClicked && styles.focusedBorder]}
                onPress={() => {
                  pickImageFromPhone();
                }}
                onPressIn={() => setIsPosterImageFormClicked(true)}
                onPressOut={() => setIsPosterImageFormClicked(false)}
              >
                <Text style={styles.photosTxt}>Image:</Text>

                {image ? (
                  <Image
                    source={{ uri: image }}
                    style={[styles.imageviewStyle2, { backgroundColor: "#d6d4d4ff" }]}
                    contentFit="cover"
                    cachePolicy="disk"
                    // onError={handleImageError}
                  />
                ) : (
                  <Image
                    style={styles.imageviewStyle2}
                    source={require("../../../assets/imagePlaceholder.jpg")}
                  />
                )}
              </TouchableOpacity>
            )}
            <Text
              style={{
                fontSize: dynamicFontSize(15),
                color: Colours.DARKGRAY,
                fontFamily: "Sen-Regular",
              }}
            >
              Location
            </Text>
            <AppTextInput
              style={[styles.formstyle, isLocationFormClicked && styles.focusedBorder]}
              placeholder="Location"
              onFocus={() => setIsLocationFormClicked(true)}
              onBlur={() => setIsLocationFormClicked(false)}
              onChangeText={(text) => {
                handleLocation(text);
              }}
            />

            <Text
              style={{
                fontSize: dynamicFontSize(15),
                color: Colours.DARKGRAY,
                fontFamily: "Sen-Regular",
              }}
            >
              Date and time
            </Text>
            {/* <AppTextInput
          style={[styles.formstyle, isDateTimeFormClicked && styles.focusedBorder]}
          placeholder="Date & Time"
          onFocus={() => setIsDateTimeFormClicked(true)}
          onBlur={() => setIsDateTimeFormClicked(false)}
          onChangeText={(text) => {
            handleDateTime(text);
          }}
        /> */}

            <TouchableOpacity
              style={[styles.formstyle, isDateTimeFormClicked && styles.focusedBorder]}
              onFocus={() => setIsDateTimeFormClicked(true)}
              onBlur={() => setIsDateTimeFormClicked(false)}
              onPress={handleCalenderDateModal2}
            >
              {/* {Object.keys(selectedBidEndDate).length === 0 ? ( */}
              {Object.keys(tableUseDate).length === 0 ? (
                isDateSelected && (
                  <View style={styles.dateBox}>
                    <Text style={styles.dateTxt}>Pick a date</Text>

                    <CalenderIcon
                      color={Colours.DARKLIGHTGRAY}
                      width={dynamicSize(25)}
                      height={dynamicSize(25)}
                    />
                  </View>
                )
              ) : (
                <View style={styles.dateBox}>
                  <Text style={styles.enteredDateTxt}>
                    {/* {selectedBidEndDate.selectedDate.toDateString()} */}
                    {tableUseDate.selectedDate.toDateString()} - {tableUseDate.selectedTime}
                  </Text>

                  <CalenderIcon
                    color={Colours.DARKLIGHTGRAY}
                    width={dynamicSize(25)}
                    height={dynamicSize(25)}
                  />
                </View>
              )}
            </TouchableOpacity>
          </View>
        )}
        {/* 
        <View style={styles.formaContainer}>
          <Text
            style={{
              fontSize: dynamicFontSize(17),
              color: Colours.DARKGRAY,
              fontFamily: "Sen-Regular",
              // marginBottom: dynamicSpacing(15),
            }}
          >
            Choose the show the table is ment for
          </Text>
        </View> */}

        {!showShowForm && (
          <View style={styles.formaContainer}>
            <Text
              style={{
                fontSize: dynamicFontSize(17),
                color: Colours.DARKGRAY,
                fontFamily: "Sen-Regular",
                marginBottom: dynamicSpacing(20),
              }}
            >
              Choose the show the table is ment for
            </Text>

            {isLoading2 && (
              <View style={{ justifyContent: "flex-start", paddingTop: 10 }}>
                <ActivityIndicator color={Colours.PRIMARY} size="small" />
              </View>
            )}
            {isError2 && (
              <View style={{ justifyContent: "flex-start", paddingTop: 10 }}>
                <Text
                  style={{
                    fontSize: dynamicFontSize(17),
                    color: Colours.PRIMARY,
                    fontFamily: "Sen-Regular",
                    marginBottom: dynamicSpacing(20),
                  }}
                >
                  Opps!! Error while fetching data
                </Text>
              </View>
            )}
            <FlatList
              data={showsData}
              scrollEnabled={false}
              keyExtractor={(item) => item._id}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={[
                    styles.showStyle,
                    selectedShowId === item._id && styles.showStyleSelected,
                  ]}
                  onPress={() => {
                    // setSelectedShowId((prev) => (prev === item._id ? null : item._id));
                    handleSelectedShow(item);
                  }}
                >
                  <Image
                    style={[styles.showImage, { backgroundColor: "#d6d4d4ff" }]}
                    source={{ uri: item.image }}
                  />
                  <Text
                    style={{
                      fontSize: dynamicFontSize(17),
                      color: Colours.DARKGRAY,
                      fontFamily: "Sen-Regular",
                      // marginBottom: dynamicSpacing(15),
                    }}
                  >
                    {item?.showCaption}
                  </Text>
                </TouchableOpacity>
              )}
            />
          </View>
        )}
        <View style={styles.formaContainer}>
          <TouchableOpacity
            style={[
              styles.greyButton2,

              {
                backgroundColor: isCreatedClicked ? Colours.PRIMARY : Colours.LIGHTEST,
              },
            ]}
            onPress={handleCreatedClicked}
            disabled={isLoading3}
          >
            {isLoading3 ? (
              <ActivityIndicator size="small" color="white" />
            ) : (
              <Text
                style={[styles.createTxt, { color: isCreatedClicked ? "white" : Colours.DARKGRAY }]}
              >
                Create
              </Text>
            )}
          </TouchableOpacity>
        </View>
        {/* </View> */}
        <Modal
          visible={isErrorCompVisible}
          transparent={true}
          animationType="fade"
          onRequestClose={() => setIsErrorCompVisible(false)}
        >
          <ErrorAlertComp
            message={errorMessage}
            onClose={() => setIsErrorCompVisible(false)}
            showDateActions={showDateActions}
            onReplaceShowDate={handleReplaceShowDate}
            onReplaceTableDate={handleReplaceTableDate}
          />
        </Modal>

        <Modal visible={isSuccessCompVisible} transparent={true} animationType="fade">
          <SuccessAlertComp
            message={successMessage}
            onClose={() => {
              setIsSuccessCompVisible(false);
              //hideModal();
            }}
          />
        </Modal>
      </ScrollView>
    </SafeAreaView>
  );
};

export default TablesForBidding;

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    display: "flex",
    // padding: dynamicSpacing(15),
    height: "100%",
  },
  formaContainer: {
    display: "flex",
    padding: dynamicSpacing(15),
    margin: dynamicSpacing(15),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
  },
  showStyle: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
    alignContent: "center",
    padding: dynamicSpacing(10),
    margin: dynamicSpacing(6),
    backgroundColor: "white",
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderRadius: dynamicSize(15),
  },
  showStyleSelected: {
    backgroundColor: Colours.LIGHTESTGREEN,
  },
  dateBox: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    // paddingHorizontal: dynamicSpacing(10),
    // paddingVertical: dynamicSpacing(10),
  },
  dateTxt: {
    color: Colours.DARKLIGHTGRAY,
    // fontSize: width * 0.03,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  enteredDateTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  formstyle: {
    display: "flex",
    padding: dynamicSpacing(15),
    marginVertical: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    fontFamily: "Sen-Regular",
    borderColor: Colours.LIGHTGRAY,
    borderWidth: dynamicSize(2),
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
  tagsViewStyle: {
    flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    marginVertical: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(3),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(15),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(17),
    backgroundColor: Colours.LIGHTGRAY,
  },
  photoViewStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // height: dynamicSize(60),
    // width: "100%",
    padding: dynamicSpacing(10),
    marginVertical: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    borderWidth: dynamicSize(2),
    borderColor: Colours.LIGHTGRAY,
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTEST,
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSize(300),
  },
  photosTxt: {
    marginRight: dynamicSpacing(100),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  imageviewStyle2: {
    width: dynamicSize(35),
    height: dynamicSize(30),
    borderRadius: dynamicSize(6),
  },
  showImage: {
    width: dynamicSize(65),
    height: dynamicSize(60),
    borderRadius: dynamicSize(10),
  },
  greyButton2: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    // marginTop: dynamicSpacing(20),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.LIGHTEST,
  },
  createTxt: {
    fontSize: dynamicFontSize(15),
    color: "white",
    fontFamily: "Sen-Bold",
  },
});
